import { render } from "./HighLevelReport.vue?vue&type=template&id=06d6fec2&scoped=true"
import script from "./HighLevelReport.vue?vue&type=script&lang=js"
export * from "./HighLevelReport.vue?vue&type=script&lang=js"

import "./HighLevelReport.vue?vue&type=style&index=0&id=06d6fec2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d6fec2"]])

export default __exports__